import React, { Component } from 'react'
import { IMAGE_DOMAIN } from 'config'
import BrandNav from 'components/BrandNav'
import './styles.css'

class RecipeDetail extends Component {
  componentDidMount() {
    document.title = '食譜'
    window.scrollTo(0, 0)
  }

  render = () => {
    const { brand, id } = this.props.match.params

    return (
      <div style={{ marginTop: '65px' }}>
        <BrandNav brand={brand} />
        <div className="container recipe">
          <img alt="recipe" src={`${IMAGE_DOMAIN}asko/recipe/${id}.jpg`} />
        </div>
      </div>
    )
  }

}

export default RecipeDetail



// WEBPACK FOOTER //
// ./src/containers/RecipeDetail/index.js